
























import mixins from 'vue-typed-mixins';
import SurveyUtils, { SurveyGroup } from '../../utils/SurveyUtils';
import { DataTableHeader } from 'vuetify';
import WorksheetUtils, { Worksheet } from '../../utils/WorksheetUtils';
export default mixins().extend({
  computed: {
    surveyGroupOptions(): any {
      return this.surveygroups?.map((group) => ({
        text: group.name,
        value: group,
      }));
    },

    surveygroup: {
      get(): SurveyGroup | undefined {
        const id = parseInt(this.$route.query.group as string);
        return this.surveygroups?.find((group) => group.id === id);
      },
      async set(group: SurveyGroup) {
        const id = parseInt(this.$route.query.group as string);
        if (group.id !== id && this.$route.name === 'worksheet-list') {
          await this.$router.push({
            name: 'worksheet-list',
            query: {
              ...this.$route.query,
              group: group?.id?.toString() || '',
            },
          });
        }
        this.load();
      },
    },

    headers(): DataTableHeader<Worksheet>[] {
      return [
        {
          text: this.$i18n.tc('model.worksheet.name'),
          value: 'name',
        },
      ];
    },

    items(): Worksheet[] | undefined {
      return this.worksheets;
    },
  },

  data(): {
    surveygroups?: SurveyGroup[];
    worksheets?: Worksheet[];
  } {
    return {
      surveygroups: undefined,
      worksheets: undefined,
    };
  },

  async mounted() {
    try {
      this.surveygroups = await SurveyUtils.api.surveyGroup.list();
      if (this.surveygroups?.length > 0 && this.$route.query.group) {
        this.surveygroup = this.surveygroups.find(
          (group) => group.id === parseInt(this.$route.query.group as string)
        );
      } else if (this.surveygroups?.length > 0 && !this.$route.query.group) {
        this.surveygroup = this.surveygroups[0];
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  watch: {
    '$route.query.group'() {
      if (
        this.surveygroups &&
        this.surveygroups.length > 0 &&
        !this.$route.query.group
      ) {
        this.surveygroup = this.surveygroups[0];
      }
    },
  },

  methods: {
    async load() {
      const currentgroup = this.surveygroup;
      if (this.surveygroup) {
        this.worksheets = undefined;
        this.$alert.hide('load');
        try {
          const resp = await WorksheetUtils.api.list({
            surveygroupid: this.surveygroup.id as number,
          });
          if (currentgroup === this.surveygroup) {
            this.worksheets = resp;
          }
        } catch (error) {
          this.$alert.show('load', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },

    async select(item: Worksheet) {
      await this.$router.push({
        name: 'worksheet-table',
        params: {
          worksheet: item?.id?.toString() || '',
        },
      });
    },
  },
});
